import React from 'react';
import clsx from 'clsx';
import { MktHubspotForm } from '../HubspotForm';

interface MktPopupFormProps {
  title: string;
  subtitle: string;
  image: string;
  isVisible: boolean;
  onClose?: () => void;
  hubSpotRegionId: string;
  hubSpotPortalId: string;
  hubSpotFormId: string;
}

export const MktPopupForm: React.FC<MktPopupFormProps> = ({
  isVisible,
  onClose,
  subtitle,
  title,
  hubSpotFormId,
  hubSpotRegionId,
  hubSpotPortalId,
  image,
}) => {
  return (
    <div
      className={clsx(
        'wh-fixed wh-left-0 wh-top-0  wh-flex wh-h-screen wh-w-screen wh-items-center wh-justify-center wh-bg-[#000000af] wh-z-[100000]',
        `${isVisible ? 'wh-visible' : 'wh-hidden'}`,
      )}
    >
      <div className="xl:flex-row wh-z-[2010] wh-m-4 wh-min-h-[437px] wh-w-[319px] wh-bg-white-off xl:wh-flex xl:wh-max-h-[850px] xl:wh-min-h-[658px] xl:wh-w-[1152px] 2xl:wh-w-[1312px]">
        <div className="wh-relative wh-h-[104px] wh-w-full xl:wh-order-2 xl:wh-h-auto xl:wh-min-h-[658px] xl:wh-w-[652px]">
          <img
            src={image}
            alt={title}
            className="wh-block wh-h-[105px] wh-w-full wh-object-cover xl:wh-h-full"
          />
          <button
            onClick={onClose}
            id="close-btn"
            className="wh-absolute wh-right-[10.63px] wh-top-[10.73px] wh-flex wh-h-[24px] wh-w-[24px] wh-items-center wh-justify-center wh-rounded-full wh-bg-light-grey wh-backdrop-blur-[7px] xl:wh-right-[16px] xl:wh-top-[16px]"
            type="button"
          >
            <i className="wh-icon wh-icon-exit wh-w-[40px] wh-pl-[3px] wh-text-[18px] wh-text-blue-dark" />
          </button>
        </div>
        <div className="wh-flex wh-h-auto wh-min-h-[333px] wh-w-full wh-flex-col wh-items-center wh-bg-white xl:wh-w-[576px] xl:wh-justify-center xl:wh-bg-white xl:wh-px-5 xl:wh-py-[50px] 2xl:wh-w-[660px] 2xl:wh-px-[80px]">
          <div className="wh-flex wh-h-auto wh-min-h-[333px] wh-w-full wh-flex-col wh-items-center wh-gap-5 wh-bg-white wh-p-5 xl:wh-min-h-[498.17px]  xl:wh-w-[500px] xl:wh-rounded-sm xl:wh-border-[1px] xl:wh-border-light-grey xl:wh-p-6">
            <div className="wh-flex wh-flex-col wh-items-center">
              <p className="wh-text-xs wh-font-medium wh-uppercase wh-tracking-widest wh-text-grey xl:wh-text-lg">
                {subtitle}
              </p>
              <h1 className="wh-font-sans wh-text-2xl wh-font-medium wh-capitalize wh-text-grey xl:wh-text-5xl">
                {title}
              </h1>
            </div>
            <div className="wh-w-full">
              <MktHubspotForm
                region={hubSpotRegionId}
                portalId={hubSpotPortalId}
                formId={hubSpotFormId}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
